import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import { CommingSoon, dateDisplayFormater } from "../../../Utils";
import InvoicePayOutUpdate from "./InvoicePayOutUpdate";
import { PaymentUpdateAction } from "../../../Reducer/PaymentUpdateReducer";
import InvoicePayInUpdate from "./InvoicePayInUpdate";
import { InvoiceNotesAction } from "../../../Reducer/InvoiceNotesReducer";
import InvoiceClientSearchForm from "./InvoiceClientSearchForm";
import { useNavigate } from 'react-router-dom';
import DataGrid from "../../controls/DataGrid.js/DataGrid";
import InvoiceSummary from "./InvoiceSummary";
import { InvoiceMeetingAction } from "../../../Reducer/InvoiceMeetingsReducer";
import { UpdtInvoiceContAction } from "../../../Reducer/UpdatedInvoiceContentReducer";


export default function Invoice() {
    const state = useSelector(state => state);
    const [invoiceDateflg, setinvoiceDateflg] = useState(false);
    const formRef = useRef();
    const [validated, setValidated] = useState(false);
    const [TotalPayoutAmt, setTotalPayoutAmt] = useState(0);
    const [TotalPayInAmt, setTotalPayInAmt] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);
    const [showPayOutModal, setshowPayOutModal] = useState(false);
    const dispatch = useDispatch();
    const [showPayInModal, setshowPayInModal] = useState(false);
    const [ShowNotes, setShowNotes] = useState(false);
    const [showSearchForm, setshowSearchForm] = useState(false);
    const navigate = useNavigate();
    const [savedSuccessfully, setSavedSuccessfully] = useState(false);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
   // const [gridUrl, setGridUrl] = useState(state.projectdetail.API + "/invoice/GetInvoiceGridList");
    const [isInvApprover, setisInvApprover] = useState(false);
    const [isCheckBxSelected, setisCheckBxSelected] = useState(false);
    const [isMarkPayinEnable, setisMarkPayInEnable] = useState(false);
    

    const [data, setData] = useState({
        Id: 0,
        ClientId: 0,
        ClientName: "",
        InvoiceNumber: "",
        InvoiceDate: "",
        InvoiceAmount: 0,
        TotalInvoiceAmount: 0,
        ReceivedAmount: 0,
        PaidtoIFAmount: 0,
        StatusId: 0,
        Status: "",
        CoOridinatorName: "",
        InvoicetypeId: 0,
        InvoicetypeName: "",
        Notes: "",
        InvoiceAge: "",
        lastUpdateAge: "",
        isModify:false

    });
    const options = {
        dataType: "server",
        showExport: false,
        showRefresh: false,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Clients",
       // toolbar: (state.access.add ? <div><Button onClick={handleAdd}>Add New PCP</Button> <Button onClick={handleAdd}>Add New Spending Plan</Button></div> : <div></div>)
    };

    const columns = [
        {
            field: "",
            title: "",
            formatter: (cellContent, rowData) => {
                return (<div>
                    {state.access.edit ? <input type="checkbox" id={"chk_" + rowData.Id}
                        className="btn-xs me-2 mb-2 p-0"
                        onClick={(e) => {
                            handleChkBox(e, rowData);
                        }}
                    /> : ""}
                </div>);
            },
        },
        {
            field: "",
            title: "Sl.No",
            formatter: (cellContent, row, rindex) => {
                return (<div>
                    {rindex + 1}

                </div>);
            },
        },
        {
            field: "ClientName",
            title: "Client Name",
            sortable: true,
            visible: true,
        },
        {
            field: "InvoiceNumber",
            title: "Invoice Number",
            sortable: true,
            visible: true,
        },
        {
            field: "InvoiceDate",
            title: "Invoice Date",
            sortable: true,
        },
        {
            field: "ReceivedAmount",
            title: "Received Amount",
            visible: true,
        },
        {
            field: "Status.Description",
            title: "Status",
            sortable: true,
            visible: true,
        },
        {
            field: "lastUpdateAge",
            title: "Age since last update.",
            sortable: true,
        },
        {
            field: "InvoiceAge",
            title: "Invoice Age",
            sortable: false,
        },
        {
            field: "CoOridinatorName",
            title: "Independant Facilitor",
            sortable: false,
            
        },
        {
            field: "CreatedByName",
            title: "Created By",
            sortable: false,

        },
        {
            field: "InvoicetypeName.Description", 
            title: "Invoice Type",
            sortable: false,

        },
        {
            dataField: "",
            title: "",
            text: "Notes",
            formatter: (cellContent, rowData) => {
                return (<div>
                    {state.access.edit ? <Button text="Notes" variant="link" tooltip="Notes"
                        className="btn-xs me-2 p-0"
                        onClick={(e) => {
                            handleNotes(e, rowData);
                        }}
                    > <Icon name="BsPencilSquare" title="Notes" className='fs-5' /></Button> : ""}
               </div> );
            },
        }
    ];

    useEffect(() => {
        let loggedUser = localStorage.getItem("user");
        let roleId = loggedUser ? JSON.parse(loggedUser).fkRoleId : 0;
        fetch(state.projectdetail.API + "/role/Get?Id=" + roleId, {
            method: "Get"
        }).then(response => response.json()).then((res) => {
            if (res) {
                setisInvApprover(res.invoiceApprover);
               // console.log("Invoice data fetched successfully");
                // console.log(data);
            }
            else {
                window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }

        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("Invoice.js ==> Invoice Get Role details", null, null, err);
            console.log(err)
        }).finally(() => {
            //setLoading(false);
        });
    }, []);

    useEffect(() => {
        let loggedUser = localStorage.getItem("user");
        dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
        dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
        fetch(state.projectdetail.API + "/invoice/getInvoiceSummaryAmtDetails", {
            method: "Get"
        }).then(response => response.json()).then((res) => {
            if (res) {
                setTotalAmount(res.TotalInvoiceAmount);
                setTotalPayoutAmt(res.TotalPayoutAmt);
                setTotalPayInAmt(res.TotalPayInAmt);
              //  setData(res.invoiceGrid);
                setinvoiceDateflg(!invoiceDateflg);
            }
            else {
                window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }

        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
            console.log(err)
        }).finally(() => {
            //setLoading(false);
        });
    }, [refreshGrid]);

    useEffect(() => {
        if (state.selPayUpdtData != null && state.selPayUpdtData?.Id > 0) {
            if (state.selPayUpdtData?.ReceivedAmount > 0) {
                if (state.selPayUpdtData?.StatusDescription !== 'Fully Settled') {
                    setisCheckBxSelected(true);
                }
            } else { setisCheckBxSelected(false); }
            if (state.selPayUpdtData?.StatusDescription === 'Approved' || state.selPayUpdtData?.StatusDescription === 'Partial Payment Recd' || state.selPayUpdtData?.StatusDescription === 'Full Payment Recd' || state.selPayUpdtData?.StatusDescription === 'Fully Settled' || state.selPayUpdtData?.StatusDescription === 'Partially Settled') {
               // if (state.selPayUpdtData?.ReceivedAmount > 0 && state.selPayUpdtData?.InvoiceAmount > 0) {
                //    if (state.selPayUpdtData?.InvoiceAmount > state.selPayUpdtData?.ReceivedAmount) {
                        setisMarkPayInEnable(true);
               //     }
              //  }
              //  }
            } else {
                setisMarkPayInEnable(false);
            }
          
        } else {
            setisCheckBxSelected(false);
            setisMarkPayInEnable(false);
        }
    }, [state.selPayUpdtData]);

    const handleChkBox = (e, rowData) => {
        if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
            var selectedChkbox = "chk_" + state.selPayUpdtData.Id;
            if (document.getElementById(selectedChkbox).checked) {
                document.getElementById(selectedChkbox).checked = false;
            }
        }
        dispatch({ type: PaymentUpdateAction.SelectPaymentUpdateData, payload: rowData });
        console.log(rowData);

    }
    const handlePayOutModal = () => {
        setshowPayOutModal(true);
    }
    const ClosePayOutUpdate = () => {
        setshowPayOutModal(false);
    }
    const handlePayInModal = () => {
        setshowPayInModal(true);
    }
    const ClosePayInUpdate = () => {
        setshowPayInModal(false);
    }

    const handleAftPayUpdate = (savedstatus) => {
        console.log("Payment Update Saved");
        setshowPayOutModal(false);
        setRefreshGrid(!refreshGrid);
   }
    const handleAftPayInUpdate = (savedstatus) => {
        setshowPayInModal(false);
        setRefreshGrid(!refreshGrid);
       // setRefreshGrid(!refreshGrid);

    }
    const handleNotes = (e, rowData) => {
        dispatch({ type: InvoiceNotesAction.AddInvIDForNotes, payload: rowData.Id })
        setShowNotes(!ShowNotes);
    }

    const handleNewInvoice = () => {
        dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
        dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
        setshowSearchForm(true);
    }
    const handleClose = ()=>{
        setshowSearchForm(false);
    }
    const handleAfter = () => {
       // console.log("Client selected");
    }
    const handleModify = (rowData) => {
        let url = "/admin/pcpform/" + rowData.ClientId + "/pcpinvoicegenerator?invid="+rowData.Id
        navigate(url);
    }

    

    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
        <div>
           
            <Row>
                {/*<Col>*/}
                {/*    <Card className="border">*/}
                {/*        <Card.Body>*/}
                {/*        </Card.Body>*/}
                {/*    </Card>*/}
                {/*</Col>*/}
            </Row>
            <Row>
                <Col>
                    <Card className="border">
                        <Card.Body>
                                <Row md={12}>
                                <Col md={1}>
                                        {/*<b> Invoice List:</b>*/}
                                </Col>
                                <Col md={2}>
                                    {/*<div>Total Invoice Amount</div>*/}
                                        <div><Form.Group>
                                            <Form.Label>Total Invoice Amount</Form.Label>
                                            <Form.Control type="text" name="TotalAmount" value={TotalAmount} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={2}>
                                        <div><Form.Group>
                                            <Form.Label>Total Pay-in Amount</Form.Label>
                                            <Form.Control type="text" name="TotalPayInAmt" value={TotalPayInAmt} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={2}>
                                        <div><Form.Group>
                                            <Form.Label>Total Pay-out Amount</Form.Label>
                                            <Form.Control type="text" name="TotalPayoutAmt" value={TotalPayoutAmt} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={3}>
                                        {isInvApprover &&
                                            <Button variant="primary" disabled={!isCheckBxSelected }  onClick={handlePayOutModal}>
                                                IF Pay-Out
                                            </Button>}
                                        &nbsp;&nbsp;
                                        {isInvApprover &&
                                            <Button variant="primary" disabled={!isMarkPayinEnable} onClick={handlePayInModal}>
                                                Mark Pay-In
                                        </Button>
                                        }
                                        {/*&nbsp;&nbsp;*/}
                                        {/*<Button variant="primary" onClick={CommingSoon}>*/}
                                        {/*    Export*/}
                                        {/*</Button>*/}
                                        {/*&nbsp;&nbsp;*/}
                                        {/*<Button variant="primary" onClick={CommingSoon}>*/}
                                        {/*    Filter*/}
                                        {/*</Button>*/}
                                    </Col>
                                    
                                    <Col md={2}>
                                        <div> <Button variant="primary" onClick={handleNewInvoice}>
                                            New Invoice
                                        </Button></div>
                                    </Col>
                                    
                </Row>
 {/*               <Row>*/}
 {/*                   <Col md={12}>*/}
 {/*                           <Table responsive className="table" style={{border: '1' }}>*/}
 {/*                       <thead border='1'>*/}
                            
 {/*                               <th md={1} border='1'></th>*/}
 {/*                               <th md={1} border='1'>Sl.No</th>*/}
 {/*                               <th md={3} border='1'>ClientName</th>*/}
 {/*                               <th md={1}>Invoice Number</th>*/}
 {/*                               <th md={1}>Invoice Date</th>*/}
 {/*                               <th md={1}>Invoice Amount</th>*/}
 {/*                               <th md={1}>Received Amount</th>*/}
 {/*                               */}{/*<th md={1}>Paid to IF Amount</th>*/}
 {/*                               <th md={1}>Status</th>*/}
 {/*                               <th md={1}>Age since Last update</th>*/}
 {/*                               <th md={1}>Invoice Age</th>*/}
 {/*                               <th md={1}>Independant Facilitator(IF)</th>*/}
 {/*                               */}{/*<th md={1}>FMS/RC</th>*/}
 {/*                               <th md={1}>Invoice Type</th>*/}
 {/*                               <th md={1}>Notes</th>*/}
 {/*                           </thead>*/}
                        
 {/*                       <tbody>*/}
 {/*                           {data && data.length > 0 && data.map((rowData, rindex) => {*/}
 {/*                               return (*/}
 {/*                                   <tr key={rindex}>*/}
 {/*                                       <td>*/}
 {/*                                           <input type="checkbox" id={"chk_" + rowData.Id}*/}
 {/*                                               className="btn-xs me-2 mb-2 p-0"*/}
 {/*                                               onClick={(e) => {*/}
 {/*                                                   handleChkBox(e, rowData);*/}
 {/*                                               }}*/}
 {/*                                           />*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rindex + 1}*/}
 {/*                                       </td> {rowData.isModify}*/}
 {/*                                       {rowData.ClientName}*/}
 {/*                                       <td>{rowData.isModify && */}
 {/*                                           state.access.edit ? <Button*/}
 {/*                                               className="btn-xs me-2 mb-2 p-0" variant="link"*/}
 {/*                                               onClick={() => handleModify(rowData)}*/}
 {/*                                           >{rowData.InvoiceNumber}</Button> : ""*/}
 {/*                                       }*/}
 {/*                                           {!rowData.isModify &&  */}
 {/*                                           rowData.InvoiceNumber}*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {dateDisplayFormater(rowData.InvoiceDate)}*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.InvoiceAmount}*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.ReceivedAmount}*/}
 {/*                                       </td>*/}
 {/*                                       */}{/*<td>*/}
 {/*                                       */}{/*    {rowData.PaidtoIFAmount}*/}
 {/*                                       */}{/*</td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.Status.Description}*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.InvoiceAge }*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.lastUpdateAge}*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.CoOridinatorName}*/}
 {/*                                       </td>*/}
 {/*                                       */}{/*<td>*/}
 {/*                                       */}{/*    FMS/RC*/}
 {/*                                       */}{/*</td>*/}
 {/*                                       <td>*/}
 {/*                                           {rowData.InvoicetypeName.Description }*/}
 {/*                                       </td>*/}
 {/*                                       <td>*/}
 {/*                                           <Button text="Notes" variant="link" tooltip="Notes"*/}
 {/*                                               className="btn-xs me-2 p-0"*/}
 {/*                                               onClick={(e) => {*/}
 {/*                                                   handleNotes(e, rowData);*/}
 {/*                                               }}*/}
 {/*                                           > <Icon name="BsPencilSquare" title="Notes" className='fs-5' /></Button>*/}
 {/*                                       </td>*/}
 {/*                                   </tr>*/}

 {/*                               )*/}
 {/*                           }*/}
 {/*                           )*/}
 {/*                           }*/}

 {/*                           <tr>*/}

 {/*                           </tr>*/}
 {/*                       </tbody>*/}
 {/*                   </Table>*/}
 {/*               </Col>*/}
 {/*</Row>*/}
       <Row>
                                    <Col>
                                        <InvoiceSummary refresh={refreshGrid} />
                                    </Col>
                                </Row>
        {/*<Row>*/}
        {/*<Col md={12}>*/}
        {/*<Card>*/}
        {/*<Card.Body>*/}
        {/*{loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}*/}
        {/*<DataGrid url={gridUrl} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />*/}
        {/*</Card.Body>*/}
        {/*</Card>*/}
        {/*</Col>*/}
        {/*</Row>*/}


                <Modal size="lg" show={showPayOutModal} onHide={ClosePayOutUpdate}  backdrop="static">
                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                <h4>Pay out Update</h4>
                <CloseButton onClick={ClosePayOutUpdate} className="btn-close" />
                </Modal.Header>
                 <Modal.Body>
                <InvoicePayOutUpdate afterSave={handleAftPayUpdate} _inputValue={data} onCancel={ClosePayOutUpdate} />
                </Modal.Body>
                </Modal>

                <Modal show={showPayInModal} onHide={ClosePayInUpdate} size="lg" backdrop="static">
                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                <h4>Pay In Amount Update</h4>
                <CloseButton onClick={ClosePayInUpdate} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                <InvoicePayInUpdate afterSave={handleAftPayInUpdate} _inputValue={data} onCancel={ClosePayInUpdate} />
                </Modal.Body>
             </Modal>
            {/*ClientSearchForm*/}

                                <Modal show={showSearchForm} onHide={handleClose}
                                    size="xl" backdrop="static" keyboard={false}
                                    dialogClassName="custom-modal-position" scrollable style={{ overflow: "hidden" }} >
            <Modal.Header style={{ background: "#0a4081", color: "white" }}>
            <h4 style={{ fontcolor: 'white' }} > Search Client details </h4>
            <CloseButton onClick={handleClose} className="btn-close" />
            </Modal.Header>
            <Modal.Body>
            <InvoiceClientSearchForm afterSave={handleAfter} onCancel={handleClose} />
            </Modal.Body>
            </Modal>

            
        </Card.Body>
        </Card>
    </Col>
    </Row>
    </div>
</Form>
</ErrorBoundary>
    );
}
        
